export const FAX_QUEUE_STATUSES = {
    QUEUED: 'Queued',
    ADDED_TO_SRFAX: 'Added',
    ERROR: 'Failed',
    CANCELLED: 'Cancelled',
    SENT: 'Sent',
};
